// src/components/Banner.js

import * as React from 'react';
import { Box, Typography } from '@mui/material';



export default function Banner({
  title = "Welcome to your Dashboard!",
  subtitle = "Explore insights and manage your resources efficiently.",
  

  
  imageUrl = "/bannerImage.jpg", 
  
  height = 240,
}) {
  return (
    <Box
      sx={{
        width: '100%',
        height: height,
        // Τώρα αυτό θα δουλέψει σωστά
        backgroundImage: `url(${imageUrl})`, 
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        textShadow: '2px 2px 4px rgba(0,0,0,0.6)',
        borderRadius: 2,
        mb: 4,
        textAlign: 'center',
        p: 2,
      }}
    >
      <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
      <Typography variant="h6" sx={{ mt: 1 }}>
        {subtitle}
      </Typography>
    </Box>
  );
}